import React, { useRef, useState, useEffect } from 'react';
import { useFrame } from '@react-three/fiber';
import { Html, Line } from '@react-three/drei'
import * as THREE from 'three';
import * as tf from '@tensorflow/tfjs';
import { Typography } from '@mui/material';


const TensorVisualizer = (props) => {
  // if (!tensor || !tf.isTensor(tensor) || tensor.rank !== 2) {
  //   return <div>Invalid tensor or not a 2D tensor</div>;
  // }

  const shape = props.tensor.shape;
  const data = props.tensor.arraySync();

  return (
    <Html fullscreen>
      <div className="matrix">
        <Typography className="labels">Parameters <b>W</b></Typography>
        <table>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr key={rowIndex} style={{color: props.colors[rowIndex]}}>
                {row.map((value, colIndex) => (
                  <td key={colIndex}>{value.toFixed(2)}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Html>
  );
};


function Hyperplane(props) {
    const ref = useRef();

    // useEffect(() => {
    //     let dir = new THREE.Vector3(...props.normal);
    //     dir.z = 0;
    //     ref.current.lookAt(dir);
    // });

    return (
        <Line
        color={props.color}
        points={[[-100 * props.normal.y, 100 * props.normal.x, 0],
                 [100 * props.normal.y, -100 * props.normal.x, 0]]}
        linewidth={2.}
        ref={ref}
        />)
    // Look at below if you care about 3D case
    // return (
    //     <mesh                                                                                                                                                                                          {...props}
    //     ref={ref}                                                                                                                                                                                      // rotation={rot}
    //     // scale={clicked ? 1.5 : 1}                                                                                                                                                                   onPointerOver={(event) => hover(true)}
    //     onPointerOut={(event) => hover(false)}>                                                                                                                                                        <planeGeometry args={[23, 23]} />
    //     <meshPhysicalMaterial side={THREE.DoubleSide} color={props['color']} transparent={true} opacity={hovered? .4 : .9} />
    //     </mesh>
    // )
}



const DraggableArrowComponent = (props) => {
  const arrowRef = useRef();
  const [isDragging, setIsDragging] = useState(false);
  const [hovered, hover] = useState(false)
  const [length, setLength] = useState(.5);
  const position = new THREE.Vector3(0, 0, 0);
  const color = props.color || new THREE.Color(0x0000ff);
  // const raycaster = new THREE.Raycaster();
  // const mouse = new THREE.Vector2();

  // For rotating the arrow
  const onDocumentMouseMove = event => {
    if (isDragging) {
      // const x = (event.clientX / window.innerWidth) * 2 - 1;
      // const y = -(event.clientY / window.innerHeight) * 2 + 1;
      // const p = new THREE.Vector3(event.pointer.x, event.pointer.y, 0);
      const p = new THREE.Vector3(event.pointer.x, event.pointer.y, 0);

      setLength(p.length());
      props.setDirection(props.rowIndex, p);
    }
  };

  const onPointerDown = (event) => {
    if (intersectsArrow(event)) {
      setIsDragging(true);
    }
  };

  const onPointerUp = (event) => {
    setIsDragging(false);
  };

  const intersectsArrow = (event) => {
    if (event.object.type === 'Mesh') {
      return true;
    }
    return false;
  };

  return (
    <group>
      <arrowHelper
        ref={arrowRef}
        args={[props.direction.normalize(), position, length, color, .1, .05]}
        // transparent={true} opacity={hovered? .4 : .9} 
        onPointerMove={onDocumentMouseMove}
        onPointerDown={onPointerDown}
        onPointerUp={onPointerUp}
        // onPointerOver={(event) => hover(true)}
        // onPointerOut={(event) => hover(false)}
      />
      <Hyperplane color={color} normal={props.direction.normalize()} />
    </group>
      );
}


const TensorViz = (props) => {
  const boardRef = useRef();

  return (
      <group ref={boardRef}>
          {props.tensor.arraySync().map((row, rowIndex) => (
            <DraggableArrowComponent
            key={rowIndex}
            rowIndex={rowIndex}
            direction={new THREE.Vector3(row[0], row[1], 0)}
            setDirection={props.setRow}
            color={props.colors[rowIndex]} />
          ))}
        <TensorVisualizer tensor={props.tensor} colors={props.colors} />
      </group>
  );
}

export default TensorViz;
